<template>
  <div>
    <div>
      <FilterCard
        :applied-filter-count="appliedFilterCount"
      >
        <b-row>
          <b-col
            cols="6"
            md="3"
          >
            <b-form-group
              label="Reason"
              label-for="v-name"
            >
              <b-form-input
                id="v-name"
                v-model="filters['name']"
                placeholder="Search"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="6"
            md="3"
          >
            <b-form-group
              label="Status"
              label-for="status"
            >
              <v-select
                v-model="filters['status']"
                :options="statusOptions"
                :reduce="option => option.key"
                label="name"
                placeholder="Select Status"
                class="status-dropdown"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Apply and Clear Filters -->
        <b-row class="mt-1">
          <b-col>
            <filter-buttons
              :filter-data="filters"
              :apply-filters="applyFilters"
              :clear-filters="clearFilters"
            />
          </b-col>
        </b-row>
      </FilterCard>
    </div>
    <div>
      <b-card
        no-body
      >
        <div>
          <div
            class="m-2"
          >
            <!-- input -->
            <b-row>
              <b-col
                class="d-flex align-items-center justify-content-start mb-md-0"
              >
                <b-button
                  v-can="'reason-create'"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  class="custom-button-color"
                  @click="onClickCreate"
                >
                  <feather-icon icon="PlusIcon" />
                  Add New
                </b-button>
              </b-col>
              <b-col
                class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
              >
                <ReportTableButtons
                  :items="rows"
                  :json_fieldz="json_fields"
                  :name="`Reasons - Page ${page}.xls`"
                  :bulkname="`Reasons.xls`"
                  :fetch="fetchReasonListNoPagination"
                  @refresh="onClickRefresh"
                />
              </b-col>
            </b-row>
          </div>

          <!-- table -->
          <b-overlay
            id="overlay-background"
            blur="10px"
            opacity="0.30"
            rounded="sm"
            variant="light"
          >
            <b-table
              :fields="fields"
              :items="rows"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              hover
              responsive
              striped
              show-empty
              @sort-changed="sortChanged"
            >
              <template #empty>
                <TableDataFetching
                  :rows="rows"
                  :data-loading="dataLoading"
                />
              </template>
              <template #head()="{ field }">
                <div
                  class="sortable-header"
                >
                  <span class="header-text">{{ field.label }}</span>
                  <feather-icon
                    v-if="field.sortable"
                    :icon="sort === field.key
                      ? 'ArrowUpIcon'
                      : 'ArrowDownIcon'"
                    size="14"
                  />
                </div>
              </template>
              <template #cell(name)="data">
                <div class="d-flex align-items-center">
                  <b-avatar
                    :text="avatarText(data.item.name)"
                    size="32"
                    variant="light-primary"
                  />
                  <div>
                    <div class="font-weight-bolder ml-1">
                      {{ data.item.name }}
                    </div>
                    <div class="font-small-2 ml-1">
                      {{ data.item.ref_no }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(created_at)="data">
                {{ __dateTimeFormatter(data.value) }}
              </template>
              <template #cell(updated_at)="data">
                {{ __dateTimeFormatter(data.value) }}
              </template>

              <template #cell(status.name)="data">
                <ul>
                  <li
                    v-for="statuskeys in data.item.status.map(n => n.key)"
                    :key="statuskeys"
                    style="list-style: none"
                    class="mb-1"
                  >
                    <order-status-badge :status-key="statuskeys" />
                  </li>
                </ul>
              </template>
              <template #cell(is_active)="data">
                <b-badge :variant="data.value === true ?'light-success':'light-danger'">
                  {{ data.value > 0 ? 'Yes' : 'No' }}
                </b-badge>
              </template>
              <template #cell(added_user)="data">
                <div
                  v-if="data.value"
                  class="d-flex align-items-center"
                >
                  <div>
                    <div class="font-weight-bold">
                      {{ data.value.first_name }} {{ data.value.last_name }}
                    </div>
                    <small>{{ data.value.role_name }}</small>
                  </div>
                </div>
                <div
                  v-else
                  class="font-weight-bold"
                >
                  {{ 'System Default' }}
                </div>
              </template>
              <template #cell(updated_user)="data">
                <div
                  v-if="data.value"
                  class="d-flex align-items-center"
                >
                  <div>
                    <div class="font-weight-bold">
                      {{ data.value.first_name }} {{ data.value.last_name }}
                    </div>
                    <small>{{ data.value.role_name }}</small>
                  </div>
                </div>
                <div
                  v-else
                  class="font-weight-bold"
                >
                  {{ '---' }}
                </div>
              </template>
              <template #cell(action)="data">
                <b-dropdown
                  no-caret
                  toggle-class="text-decoration-none"
                  variant="link"
                >
                  <template v-slot:button-content>
                    <feather-icon
                      class="text-body align-middle mr-25"
                      icon="MoreVerticalIcon"
                      size="12"
                    />
                  </template>
                  <b-dropdown-item
                    v-can="'reason-show'"
                    @click="onClickUpdate(data.item.id)"
                  >
                    <feather-icon icon="ToolIcon" />
                    Manage Reason
                  </b-dropdown-item>
                </b-dropdown>
              </template>

            </b-table>

            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  class="d-flex align-items-center justify-content-sm-start"
                  cols="12"
                  md="3"
                >
                  <label>Per page</label>
                  <v-select
                    v-model="perPage"
                    :clearable="false"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="pageOptions"
                    class="per-page-selector d-inline-block ml-1 width-100 mr-1"
                  />
                </b-col>
                <!-- Pagination -->
                <b-col
                  class="d-flex align-items-center justify-content-sm-end"
                  cols="12"
                  md="9"
                >
                  <span class="text-muted mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
                  <b-pagination
                    v-model="page"
                    :per-page="perPage"
                    :total-rows="(meta.total)? meta.total : 0"
                    class="mb-0 mt-1 mt-sm-0"
                    first-number
                    last-number
                    next-class="next-item"
                    prev-class="prev-item"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </b-overlay>
        </div>
      </b-card>
    </div>

    <set-reason ref="set_reason" />

  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BFormGroup,
  BFormInput,
  BRow,
  BOverlay,
  VBModal,
  BTable,
  BDropdown,
  BDropdownItem,
  BAvatar,
  VBTooltip,
  BPagination,
  BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Filter from '@core/mixins/filter'
import vSelect from 'vue-select'
import OrderStatusBadge from '@core/components/status/OrderStatusBadge.vue'
import { avatarText } from '@core/utils/filter'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import store from '@/store'
import SetReason from '@/components/reasons/SetReasonModal.vue'
import FilterButtons from '@/components/Filter/FilterButtons.vue'
import tableMixin from '@core/mixins/tableMixin'
import FilterCard from '@/components/FilterCard/FilterCard.vue'

const ReasonRepository = RepositoryFactory.get('reasons')

export default {
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    FilterCard,
    BFormGroup,
    BFormInput,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BOverlay,
    vSelect,
    BDropdown,
    BDropdownItem,
    BPagination,
    BAvatar,
    BBadge,
    SetReason,
    OrderStatusBadge,
    FilterButtons,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, tableMixin],
  data() {
    return {
      avatarText,
      filters: {},
      total: 0,
      meta: {},
      dataLoading: false,
      // Start BS Table
      sort: '',
      perPage: 20,
      pageOptions: [10, 20, 50],
      page: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      dir: false,
      recordId: 0,
      fields: [
        {
          key: 'id',
          label: '#',
          sortable: true,
          thClass: 'd-none',
          tdClass: 'd-none',
        },
        {
          key: 'name',
          label: 'Reason',
          sortable: true,
          tdClass: 'text-left',
        },
        {
          key: 'description',
          label: 'Description',
          sortable: true,
        },
        {
          key: 'status.name',
          label: 'Status',
          sortable: true,
        },
        {
          key: 'created_at',
          label: 'Created Date',
          sortable: true,
        },
        {
          key: 'updated_at',
          label: 'Updated Date',
          sortable: true,
        },
        {
          key: 'is_active', label: 'Is Active', sortable: true, thClass: ' text-center', tdClass: ' text-center',
        },
        {
          key: 'added_user',
          label: 'Added By',
          sortable: false,
        },
        {
          key: 'updated_user',
          label: 'Updated By',
          sortable: false,
        },
        {
          key: 'action',
          label: 'Action',
          sortable: false,
        },
      ],
      json_fields: {
        Reason: {
          field: 'name',
          callback: value => `"${value}"`,
        },
        Description: {
          field: 'description',
          callback: value => `"${value}"`,
        },
        Status: {
          field: 'status',
          callback: value => `"${value.map(n => n.name)}"`,
        },
        'Created Date': {
          field: 'created_at',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        'Updated Date': {
          field: 'updated_at',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        'Is Active': {
          field: 'is_active',
          callback: value => `"${value}"`,
        },
        'Added By': {
          callback: value => `"${value.added_user !== null ? `${value.added_user.first_name}` : 'System Default'} ${value.added_user !== null && value.added_user.last_name !== null ? `${value.added_user.last_name}` : ''}"`,
        },
        'Added User Role': {
          callback: value => `"${value.added_user !== null && value.added_user.role_name !== null ? `${value.added_user.role_name}` : 'N/A'}"`,
        },
        'Updated By': {
          callback: value => `"${value.updated_user !== null ? `${value.updated_user.first_name}` : 'N/A'} ${value.updated_user !== null && value.updated_user.last_name !== null ? `${value.updated_user.last_name}` : ''}"`,
        },
        'Updated User Role': {
          callback: value => `"${value.updated_user !== null && value.updated_user.role_name !== null ? `${value.updated_user.role_name}` : 'N/A'}"`,
        },
      },
      rows: [],
      statusOptions: [],
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  watch: {
    page() {
      this.fetchReasonList()
    },
    perPage() {
      this.fetchReasonList()
    },
  },
  mounted() {
    // Set the initial number of items
    this.fetchReasonList()
    this.readDataforStatus()
    this.updateFilterCount()
  },
  methods: {
    async fetchReasonList() {
      this.dataLoading = true
      this.rows = []
      try {
        const { data } = (await ReasonRepository.getReasonList(this.page, this.filterQuery, this.perPage))
        this.rows = data.data
        this.meta = data.meta
      } catch (e) {
        this.showErrorMessage(e)
      }
      this.dataLoading = false
    },
    async fetchReasonListNoPagination() {
      try {
        const { data } = (await ReasonRepository.getReasonListNoPagination(this.filterQuery))
        return data.data
      } catch (e) {
        this.showErrorMessage(e)
        return []
      }
    },
    async readDataforStatus() {
      try {
        const { data } = (await ReasonRepository.getStatusList()).data
        this.statusOptions = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    onClickCreate() {
      this.$refs.set_reason.openModal(null, 'add')
    },
    onClickUpdate(id) {
      this.$refs.set_reason.openModal(id, 'edit')
    },
    applyFilters() {
      this.fetchReasonList()
      this.updateFilterCount()
    },
    clearFilters() {
      this.filters = {}
      this.$nextTick(() => {
        this.fetchReasonList()
      })
      this.updateFilterCount()
    },
    handleChangePage(page) {
      this.page = page
      this.fetchReasonList()
    },
    changePage(value) {
      this.perPage = value
    },
    onClickRefresh() {
      this.fetchReasonList()
    },
  },
}
</script>
<style lang="scss">
@import '../@core/scss/vue/libs/vue-select.scss';
@media (min-width: 767px) {
  .status-dropdown .vs__dropdown-menu {
    width: fit-content;
  }
}
</style>
